import { init } from '@sentry/browser';
import configurations from '../../configurations.json';
import { version, name } from '../../../package.json';

// -----------------------------------------------------------------------------
export class Sentry {
  // ---------------------------------------------------------------------------
  public static initSentry() {
    init({
      dsn: configurations.sentry.dns,
      sampleRate: configurations.sentry.sampleRate,
      release: `${name}@${version}`,
      attachStacktrace: true,
      autoSessionTracking: false,
    });
  }
}
